module.exports = __webpack_public_path__ + "img/setting.9a1f79cd.svg";